import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { TermsAndConditionsListComponent } from './terms-and-conditions-list/terms-and-conditions-list.component';
import { TermsAndConditionsDetailComponent } from './terms-and-conditions-detail/terms-and-conditions-detail.component';
import { TermsAndConditionsConsentListComponent } from './terms-and-conditions-consent-list/terms-and-conditions-consent-list.component';

const routes: Routes = [
  {
    path: 'terms-and-conditions',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: TermsAndConditionsListComponent },
      { path: 'new', component: TermsAndConditionsDetailComponent, canDeactivate: [UnloadGuard] },
      {
        path: 'consent',
        children: [
          { path: ':cookieId', component: TermsAndConditionsConsentListComponent, canDeactivate: [UnloadGuard] },
        ],
      },
      { path: ':cookieId', component: TermsAndConditionsDetailComponent, canDeactivate: [UnloadGuard] },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class TermsAndConditionsRoutingModule {}
